'use client'

import { useTranslations } from 'next-intl'

import { PageNotFound } from '@/shared/asset'
import { Link } from '@/shared/i18n'
import { useSession } from '@/shared/lib'
import { Button } from '@/shared/ui'
import { NavigationBarUI } from '@/widgets/navigation-bar'

export const ErrorPage = () => {
  const t = useTranslations('common.error')

  const session = useSession()
  const isLoggedIn = !!session.data
  const isHost = session.data?.isHost

  return (
    <>
      <NavigationBarUI isLoggedIn={isLoggedIn} isHost={isHost} />
      <div className="flex h-[calc(100vh-72px)] flex-col items-center bg-gray-50 pt-30">
        <PageNotFound className="mb-6 block" />
        <h2 className="typo-headline2 mb-4 font-bold text-black">
          {t('server.title')}
        </h2>
        <p className="typo-body1 mb-10 text-center font-normal whitespace-break-spaces text-gray-900">
          {t('server.description')}
        </p>
        <Button
          asChild
          variant="solid"
          color="primary"
          size="large"
          className="w-60"
        >
          <Link href="/">{t('button.home')}</Link>
        </Button>
      </div>
    </>
  )
}
